// import styleReset from '../reset.shadow.less';
import styleDialog from '../styles/dialog.shadow.less';
import styleInput from '../styles/input.shadow.less';

import styleSelectMulti from './select-multi.shadow.less';

import '../select-option/select-option';

import {escapeRegExp} from '../../js/helper/helper';

class SelectMulti extends HTMLElement {
    constructor(){
        super();
        this.root = this.attachShadow({ mode: 'open' });
        this.applyStyle(styleDialog);
        this.applyStyle(styleInput);
        this.applyStyle(styleSelectMulti);

        // 原始的項目以及順序
        this.originalItems = [];

        // 使用者選擇的項目 (選擇過後的順序無法保證相同)
        this.selectedItems = [];

        // 初始化 shadow DOM 結構 (不含內容)
        this.init();
    }

    // === 注入樣式 === //
    applyStyle(style){
        const elem = document.createElement('style');
        elem.textContent = style;
        this.root.appendChild(elem);
    }

    // === 初始化，在 constructor 中執行 === //
    init(){
        const buttonText = window.t('common.button');

        const container = document.createElement('div');
        container.className = 'container';

        container.innerHTML =
        `<div class="overlay"></div>
        <div class="dialog">
            <div class="title"></div>
            <div class="controls">
                <div class="btn" data-action="select-all">${buttonText.selectAll}</div>
                <div class="btn" data-action="deselect-all">${buttonText.deselectAll}</div>
            </div>
            <div class="filterwpr hide"></div>
            <div class="scrollwpr">
                <div class="contentwpr"></div>
            </div>
            <div class="btnwpr">
                <div class="btn cancel">
                    <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#times"></use></svg>${buttonText.cancel}
                </div>
                <div class="btn confirm">
                    <svg><use xlink:="" href="/assets/sprites/sprites_solid.svg#check"></use></svg>${buttonText.confirm}
                </div>
            </div>
        </div>`;

        this.root.append(container);
    }

    // *** 以下四種內建的生命週期方法，都是 Callback 結尾 *** //

    // === 內建生命週期: 當元件被插入到 DOM 中時調用 === //
    // 與畫面實際出現、互動相關的行為，都應該放在 connectedCallback
    // 包括 UI 行為、事件綁定、資料載入、動畫等
    connectedCallback(){
        const container = this.root.querySelector('.container');

        container.addEventListener('click', (e) => {

            const target = e.target;

            // 取消
            if(target.closest('.cancel')){
                container.classList.remove('visible');
                // this.dispatchCustomEvent('select-multi-cancel', '取消');
            }

            // 確認
            if(target.closest('.confirm')){
                const data = this.originalItems.filter((item) => {
                    if(this.selectedItems.includes(item)){
                        return true;
                    }
                });
                this.dispatchCustomEvent('select-multi-confirm', {
                    host: this.root.host,
                    data: data,
                });
            }

            // 全選 / 全不選
            if(target.closest('.controls .btn')){
                const selects = container.querySelectorAll('select-option');
                const action = target.dataset.action;
                selects.forEach((select) => {
                    // 需要略過 disabled 的元件
                    if(select.getAttribute('disabled') === 'disabled'){
                        return;
                    }

                    if(action === 'select-all'){
                        // 全選
                        select.setAttribute('checked', 'checked');
                    } else if(action === 'deselect-all'){
                        // 全不選
                        select.setAttribute('checked', 'unchecked');
                    }
                });
                // console.log(this.selectedItems);
            }

            // reset filter
            const filterReset = target.closest('.reset-filter');
            if(filterReset){
                this.#handleFilter();
                const parent = filterReset.closest('.filterwpr');
                parent.querySelector('input').value = '';
            }
        });

        container.addEventListener('input', (e) => {

            const target = e.target;

            const filterInput = target.closest('input.filter');
            if(filterInput){
                const value = filterInput.value;
                const resetBtn = filterInput.parentNode.querySelector('.reset-filter');
                if(value.length > 0){
                    resetBtn.classList.remove('hide');
                } else {
                    resetBtn.classList.add('hide');
                }
                this.#handleFilter(value);
            }

        });

        // overlay 的 transition 時間比較久，所以用 overlay 當基準
        const overlay = container.querySelector('.overlay');

        overlay.addEventListener('transitionend', (e) => {
            // 在 CSS transition-property 中有指定到的屬性都會觸發 ex: opacity,visibility...
            // 為了避免重複觸發，此處以 visibility 作為代表
            if(e.propertyName === 'visibility' && !container.classList.contains('visible')){
                this.dispatchCustomEvent('select-multi-transitionend', {
                    host: this.root.host
                });
            }
        });

        // select-option custom event
        container.addEventListener('select-option-change', (e) => {
            // e.detail 中包含以下資料
            // checked: false,​
            // name: "sheetexport",            ​
            // value: "sheet2",
            const detail = e.detail;
            const value = detail.value;

            const index = this.selectedItems.findIndex((elem) => {
                if(elem === value){
                    return true;
                }
            });

            if(index > -1){
                // 在 this.selectedItems 中有值
                if(!detail.checked){
                    this.selectedItems.splice(index, 1); // 移除
                }
            } else {
                // 在 this.selectedItems 中沒有值
                if(detail.checked){
                    this.selectedItems.push(value); // 加入
                }
            }

        });

    }

    // === 內建生命週期: 當元件被移出 DOM 時調用 === //
    // 移除方法，在父層用 .remove() 從 DOM 中移除 <select-multi>
    // 如果有不是綁在 component 本身的東西
    // 在卸載時務必手動移除，以免造成 memory leak，例如以下幾種
    // 1. 綁定在 window, document, body 上的事件監聽器
    // 2. setInterval, setTimeout, WebSocket, MutationObserver 等
    disconnectedCallback(){
        // 綁定在 shadoe DOM 的事件監聽器會被自動移除，不用手動移除
        // 除此之外都需要手動移除
        // window.removeEventListener('resize', this._handleResize);
    }

    // === 內建生命週期: 當元件的屬性 (attributes) 變動時調用 === //
    // changed, added, removed, or replaced
    // 只有用 static get observedAttributes 列出的屬性才會被追蹤
    attributeChangedCallback(name, oldValue, newValue){
        if(name === 'visibility' && newValue === 'hidden'){
            // 從外部關閉
            this.root.querySelector('.container').classList.remove('visible');
        }
        if(name === 'filter' && newValue === 'enable'){
            // 啟用 filter 功能
            this.#initFilter();
        }
    }

    // 注意：如果要啟用 attributeChangedCallback()，需要搭配 getter
    // 用 static get 定義 observedAttributes
    // (瀏覽器會自動讀取 component.observedAttributes 值，來決定要監聽哪些屬性變化)
    // 所以需要指定哪些屬性需要監聽，當這些屬性改變時會觸發 attributeChangedCallback
    static get observedAttributes() {
        return ['visibility', 'filter'];
    }

    // === 內建生命週期: 元件被移到另一個 document 時（如 iframe 之間) === //
    // adoptedCallback(){

    // }

    // *** 以下為自訂方法 *** //

    // === 建立 filter === //
    #initFilter(){
        const wrapper = this.root.querySelector('.filterwpr');

        wrapper.classList.remove('hide');

        const Html =
        `<svg class="search">
            <use xlink:href="/assets/sprites/sprites_solid.svg#search"></use>
        </svg>
        <input class="uppercase filter" type="text" placeholder="篩選序號" autocomplete="one-time-code">
        <div class="reset-filter hide">
            <svg>
                <use xlink:href="/assets/sprites/sprites_solid.svg#times"></use>
            </svg>
        </div>`;

        wrapper.innerHTML = Html;
    }

    // === seeter 接收外部資料 === //
    set setData(data = null){
        if(data){
            this.render(data);
        }
    }

    // === 根據資料產生內容 === //
    render(data){

        const container = this.root.querySelector('.container');
        const contentwpr = container.querySelector('.contentwpr');

        // 如果未指定，預設用 block 樣式
        const display = data.display || 'block';

        // dialog 標題
        container.querySelector('.title').textContent = data.title;

        // 建立選項
        data.options.forEach((item) => {

            this.originalItems.push(item.value);

            if(item.skip){
                // 跳過此項目不建立選項
                // 但仍需紀錄在 originalItems 中
                return;
            }

            const checkbox = document.createElement('select-option');

            // 因為是多選選擇器，所以 input type 必須是 checkbox
            checkbox.setAttribute('type', 'checkbox');

            // name 屬性值
            checkbox.setAttribute('name', data.name);

            // inline 或 block 樣式
            if(display === 'block'){
                checkbox.setAttribute('display', 'block');
            }

            // 不可選 (不能改變值)
            if(item.disabled){
                checkbox.setAttribute('disabled', 'disabled');
            }

            // 預設全選
            checkbox.setAttribute('checked', 'checked');

            contentwpr.appendChild(checkbox);

            checkbox.setData = {
                text: item.text,
                value: item.value,
            }
        });

        // deep clone 一份清單，用來記錄已選項目
        // 因為在進行選擇後，this.selectedItems 中的順序無法保證跟原始資料相同
        this.selectedItems = structuredClone(this.originalItems);

        // 雙重 requestAnimationFrame 可確保瀏覽器完成一次 paint，再執行 class 切換
        // 比 setTimeout(..., 0) 更穩定。
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                // 把 class 切換延遲到下一輪事件循環，讓瀏覽器有時間：
                // 1. 將初始狀態繪製到畫面
                // 2. 下一輪才切換 class
                // 3. 這時才有「狀態變化」> 觸發 transition
                container.classList.add('visible');
            });
        });
    }

    // === 向外傳遞資料 === //
    // 利用 dispatchEvent 觸發自訂的事件，向上傳遞資料給父層
    dispatchCustomEvent(name, detail = {}) {
        this.dispatchEvent(new CustomEvent(name, {
            detail: detail,
            bubbles: true,
            composed: true
        }));
    }

    // === filter 行為 === //
    #handleFilter(value = null){

        const options = this.root.querySelectorAll('select-option');

        if(value && value.length > 0){
            const text = escapeRegExp(value);
            const regex = new RegExp(`(?:${text})`, 'i');

            options.forEach((elem) => {
                if(regex.test(elem.dataset.value)){
                    elem.classList.remove('hide');
                } else {
                    elem.classList.add('hide');
                }
            });
        } else {
            // value 為 null 時視為 reset，顯示所有選項
            options.forEach((elem) => {
                elem.classList.remove('hide');
            })
        }

    }

}

customElements.define('select-multi', SelectMulti);